import PropTypes from 'prop-types';
import { TextField } from '@mui/material';

const styles = {
  textField: ({ palette, breakpoints, typography }) => ({
    '.MuiInputBase-root': {
      '&::before': {
        borderColor: 'transparent !important',
      },
      '&::after': {
        borderColor: 'transparent !important',
      },
      '&.Mui-error': {
        '&::before': {
          borderColor: `${palette.error.main} !important`,
        },
        '&::after': {
          borderColor: `${palette.error.main} !important`,
        },
      },
    },
    '.MuiInputBase-input': {
      height: 60,
      ...typography['h2-bold'],
      [breakpoints.up('lg')]: {
        ...typography.h1,
      },
      '&::placeholder': {
        color: palette.colors.lightGrey,
        opacity: 1,
      },
    },
    '.MuiFormHelperText-root': {
      position: 'absolute',
      top: '100%',
      left: 0,
      marginTop: 1,
    },
  }),
};

export const QuestionNameInput = ({
  value = '',
  innerRef = null,
  error = null,
  onChange,
  customStyles = null,
  placeholder = '',
  ...props
}) => (
  <TextField
    {...props}
    fullWidth
    autoComplete="off"
    variant="standard"
    placeholder={placeholder}
    value={value}
    ref={innerRef}
    error={!!error}
    helperText={error?.message}
    onChange={(event) => onChange(event.target.value.trimStart())}
    sx={[styles.textField, customStyles]}
  />
);

QuestionNameInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  innerRef: PropTypes.func,
  error: PropTypes.shape({ message: PropTypes.string }),
  onChange: PropTypes.func.isRequired,
  customStyles: PropTypes.shape({}),
};
